"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dragIconBlock = exports.dragBlock = exports.oneBreakEvenBlock = exports.breakEvenBlock = exports.chartBlock = exports.maxAbsoluteBlock = exports.divider = exports.container = void 0;

var _util = require("../../../util");

const container = () => ({
  width: '100%',
  height: '100%',
  borderRadius: 12,
  position: 'relative',
  userSelect: 'none'
});

exports.container = container;

const divider = ({
  theme,
  cssProps: {
    top
  }
}) => ({
  position: 'relative',
  border: 0,
  borderBottom: "2px dashed ".concat((0, _util.color)(theme, 'ui3')),
  margin: 0,
  top,
  left: 0
});

exports.divider = divider;

const maxAbsoluteBlock = () => ({
  position: 'absolute',
  top: '45%',
  left: '0%'
});

exports.maxAbsoluteBlock = maxAbsoluteBlock;

const chartBlock = ({
  theme,
  cssProps: {
    gradient
  }
}) => {
  let background;

  if (gradient === 'profit') {
    background = "linear-gradient(180deg, \n      ".concat((0, _util.color)(theme, 'text.positive'), " 0%, \n      ").concat((0, _util.color)(theme, 'black'), " 30%, \n      ").concat((0, _util.color)(theme, 'text.negative'), " 50%,\n      ").concat((0, _util.color)(theme, 'black'), " 70%,\n      ").concat((0, _util.color)(theme, 'text.positive'), " 100%)");
  } else if (gradient === 'loss') {
    background = "linear-gradient(180deg, \n      ".concat((0, _util.color)(theme, 'text.negative'), " 0%, \n      ").concat((0, _util.color)(theme, 'black'), " 30%, \n      ").concat((0, _util.color)(theme, 'text.positive'), " 50%,\n      ").concat((0, _util.color)(theme, 'black'), " 70%,\n      ").concat((0, _util.color)(theme, 'text.negative'), " 100%)");
  } else {
    background = "linear-gradient(180deg, \n      ".concat((0, _util.color)(theme, 'text.positive'), " 0%, \n      ").concat((0, _util.color)(theme, 'black'), " ").concat(gradient, "%, \n      ").concat((0, _util.color)(theme, 'text.negative'), " 100%)");
  }

  return {
    position: 'absolute',
    width: 100,
    height: '100%',
    background,
    borderRadius: 12,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
};

exports.chartBlock = chartBlock;

const breakEvenBlock = ({
  cssProps: {
    top
  }
}) => ({
  position: 'absolute',
  top,
  left: '10%'
});

exports.breakEvenBlock = breakEvenBlock;

const oneBreakEvenBlock = ({
  cssProps: {
    top
  }
}) => ({
  position: 'absolute',
  top,
  left: '15%'
});

exports.oneBreakEvenBlock = oneBreakEvenBlock;

const dragBlock = ({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'absolute',
  width: '100%',
  height: 70,
  background: 'rgba(255, 255, 255, 0.9)',
  borderColor: (0, _util.color)(theme, 'ui3'),
  borderStyle: 'solid',
  borderWidth: '1px 0',
  backdropFilter: 'blur(16px)'
});

exports.dragBlock = dragBlock;

const dragIconBlock = () => ({
  cursor: 'pointer'
});

exports.dragIconBlock = dragIconBlock;
//# sourceMappingURL=PnlAnaliticsChart.style.js.map